import React, {HTMLProps, useRef} from "react";

import useScrollLock from "@/hooks/useScrollLock";

import useBackdrop from "./useBackdrop";
import useFullWidthTransition from "./useFullWidthTransition";

interface FullWidthTransitionProps extends HTMLProps<HTMLDivElement> {
    fullWidth: boolean;
    breakpoint: number;
    duration: number;
    ease: string | gsap.EaseFunction;
    onPause: () => void;
}

const FullWidthTransition = ({children, fullWidth, breakpoint, duration, ease, onPause, ...rest}: FullWidthTransitionProps) => {
    const container = useRef<HTMLDivElement>();
    const backdrop = useRef<HTMLDivElement>();

    useFullWidthTransition(container, fullWidth, breakpoint, duration, ease);
    useBackdrop(backdrop, fullWidth, duration, ease);
    useScrollLock(fullWidth);

    return (<div {...rest}>
        <div
            className='backdrop'
            onClick={onPause}
            ref={backdrop}
            style={{position: 'fixed', top: '0', left: '0', width: '100%', height: '100%', display: 'none', cursor: 'pointer', zIndex: 998}}
        />

        <div
            ref={container}
            style={{width: 'inherit', height: 'inherit', aspectRatio: 'inherit'}}
        >
            {children}
        </div>
    </div>);
};

export default FullWidthTransition;
